<template>
<div class="container">
  <div class="row">
    <div class="col-lg-6 col-md-8 mx-auto mt-5 border py-4 px-4">
      <div class="alert alert-danger" v-if="hasError">Invalid Login Credentials</div>
      <form v-on:submit.prevent="onLogin" action="">
        <input-text v-model="login.loginId" label="User ID"></input-text>
        <input-text v-model="login.loginPass" masked label="Password" group-class="mt-2"></input-text>
        <div class="text-end mt-3">
          <button type="submit" class="btn btn-primary">Login</button>
        </div>
      </form>
    </div>
  </div>
  
  <b-modal
      v-model="updateAvailable"
      header-bg-variant="dark"
      header-text-variant="warning"
      title="New version available"
      ok-only ok-title="Refresh"
      no-close-on-backdrop no-close-on-esc hide-header-close
      @ok="reload">
    <div class="text-center text-danger fw-bold">
    A new version of the app has been released.<br/>Please refresh to continue.
    </div>
  </b-modal>

</div>
</template>

<script>
export default {
  name: 'AdminLogin',
  data () {
    return {
      login: { loginId: '', loginPass: ''},
      updateAvailable: false,
      hasError: false
    }
  },
  mounted () {
    this.checkForUpdate()
  },
  methods: {
    onLogin: async function () {
        await this.checkForUpdate()
        if (this.updateAvailable) return
      this.hasError = false
      this.axios.post('/ax/login', this.login)
        .then(response => {
          this.$store.commit('saveToken', response.data)
          this.$router.push('/dashboard')
          this.$eventBus.$emit('logged-in')
        })
        .catch(error => {
          console.log(error.response.status + ': ' + error.response.data)
          this.hasError = true
        })
    },
    async checkForUpdate() {
      const running = process.env.VUE_APP_BUILD_TIME;
      if (!running || this.updateAvailable) return; // local dev, or already flagged
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { builtAt } = await res.json();
        if (builtAt !== running) this.updateAvailable = true;
      } catch (e) { /* ignore network errors */ }
    },
    reload() {
      window.location.reload();
    }    
  }
}
</script>